import TextField from "@mui/material/TextField";
import { useEcrfContext } from "../../context/EcrfContext";
import MainAccordion from "../Accordion/MainAccordion";

const VisitNameAccordion = ({ handleVisitFieldChange, isLocked = false }) => {
  const { selectedVisit } = useEcrfContext();

  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;
  const hideAccordian =
    role !== "CRO Admin" &&
    role !== "Cro_coordinator" &&
    role !== "Data Manager" &&
    role !== "Super Admin";

  return (
    !hideAccordian && (
      <MainAccordion
        title="Visit Name"
        isOpen={true}
        data={
          <TextField
            fullWidth
            size="small"
            name="visit_name"
            label="Visit Name"
            value={selectedVisit.visit_name || ""}
            onChange={(e) => handleVisitFieldChange(e)}
            disabled={hideAccordian || isLocked}
            sx={{ pb: 2, width: "175px" }}
          />
        }
      />
    )
  );
};
export default VisitNameAccordion;
